export const brand = {
  "NAME": "DTM",
  "FAVICON": "maja",
  "HELP": "",
  "LOGIN": {
    "LOGO_PATH": "gmtech_applications.svg",
    "SSO": "{baseUrl}/auth/realms/{realm}/protocol/openid-connect/auth",
    "SSO_LOGOUT": "{baseUrl}/auth/realms/{realm}/protocol/openid-connect/logout",
    "SSO_OPTIONS": {
      "TYPE": "KEYCLOAK",
      "HOSTS": {
        "vys-test.krajdtm.cz": {
          "baseUrl": "https://vys-test.krajdtm.cz",
          "realm": "VYS",
          "clientId": "maja",
          "redirectUri": "https://vys-test.krajdtm.cz/maja/"
        },
        "vys-test.krajdtm.cms2.cz": {
          "baseUrl": "https://vys-test.krajdtm.cms2.cz",
          "realm": "VYS",
          "clientId": "maja",
          "redirectUri": "https://vys-test.krajdtm.cms2.cz/maja/"
        },

        "vys.krajdtm.cz": {
          "baseUrl": "https://vys.krajdtm.cz",
          "realm": "VYS",
          "clientId": "maja",
          "redirectUri": "https://vys.krajdtm.cz/maja/"
        },
        "vys.krajdtm.cms2.cz": {
          "baseUrl": "https://vys.krajdtm.cms2.cz",
          "realm": "VYS",
          "clientId": "maja",
          "redirectUri": "https://vys.krajdtm.cms2.cz/maja/"
        },

        "jck-test.krajdtm.cz": {
          "baseUrl": "https://jck-test.krajdtm.cz",
          "realm": "JCK",
          "clientId": "maja",
          "redirectUri": "https://jck-test.krajdtm.cz/maja/"
        },
        "jck-test.krajdtm.cms2.cz": {
          "baseUrl": "https://jck-test.krajdtm.cms2.cz",
          "realm": "JCK",
          "clientId": "maja",
          "redirectUri": "https://jck-test.krajdtm.cms2.cz/maja/"
        },

        "jck.krajdtm.cz": {
          "baseUrl": "https://jck.krajdtm.cz",
          "realm": "JCK",
          "clientId": "maja",
          "redirectUri": "https://jck.krajdtm.cz/maja/"
        },
        "jck.krajdtm.cms2.cz": {
          "baseUrl": "https://jck.krajdtm.cms2.cz",
          "realm": "JCK",
          "clientId": "maja",
          "redirectUri": "https://jck.krajdtm.cms2.cz/maja/"
        },

        "dtm-test.zlinskykraj.cz": {
          "baseUrl": "https://dtm-test.zlinskykraj.cz",
          "realm": "ZLK",
          "clientId": "maja",
          "redirectUri": "https://dtm-test.zlinskykraj.cz/maja/"
        },
        "dtm-test.zlinskykraj.cms2.cz": {
          "baseUrl": "https://dtm-test.zlinskykraj.cms2.cz",
          "realm": "ZLK",
          "clientId": "maja",
          "redirectUri": "https://dtm-test.zlinskykraj.cms2.cz/maja/"
        },

        "dtm.zlinskykraj.cz": {
          "baseUrl": "https://dtm.zlinskykraj.cz",
          "realm": "ZLK",
          "clientId": "maja",
          "redirectUri": "https://dtm.zlinskykraj.cz/maja/"
        },
        "dtm.zlinskykraj.cms2.cz": {
          "baseUrl": "https://dtm.zlinskykraj.cms2.cz",
          "realm": "ZLK",
          "clientId": "maja",
          "redirectUri": "https://dtm.zlinskykraj.cms2.cz/maja/"
        },

        "dtm-test-olomoucky.tmapserver.cz": {
          "baseUrl": "https://dtm-test-olomoucky.tmapserver.cz",
          "realm": "OLK",
          "clientId": "maja",
          "redirectUri": "https://dtm-test-olomoucky.tmapserver.cz/maja/"
        },
        "olk-test.prod.gmtech.cz": {
          "baseUrl": "https://dtm-test-olomoucky.tmapserver.cz",
          "realm": "OLK",
          "clientId": "maja",
          "redirectUri": "https://olk-test.prod.gmtech.cz/maja/"
        },
        "isdtm.olkraj.cz": {
          "baseUrl": "https://isdtm.olkraj.cz",
          "realm": "OLK",
          "clientId": "maja",
          "redirectUri": "https://isdtm.olkraj.cz/maja/"
        },
        "isdtm.olkraj.cms2.cz": {
          "baseUrl": "https://isdtm.olkraj.cms2.cz",
          "realm": "OLK",
          "clientId": "maja",
          "redirectUri": "https://isdtm.olkraj.cms2.cz/maja/"
        }
      }
    },
    "APP_URL": "https://gmtech.cz"
  },
  "PS": {
    "TITLE": "MAJA",
    "ICON_PATH": "maja",
    "URL_BASE_PATH": "maja"
  },
  "VISIBILITY": {
    "maja": true,
    "mpv": false,
    "common.navbar.big": false,
    "common.navbar.small": true,
    "sv.unit": true,
    "settings.modules.ps": true,
    "settings.modules.pk": false,
    "settings.modules.dimap": false,
    "settings.modules.vfze": false
  },
  "TRANSLATE": {
    "ps.project": "Projekt",
    "ps.projects": "Projekty",
    "ps.projectGenitive": "Projektu",
    "ps.projectAccusative": "Projekt",
    "ps.projectsAccusative": "Projektů",
    "ps.projectList": "Seznam projektů",
    "ps.projectList.total": "Celkový počet případů",
    "ps.projectList.done": "Celkový počet vypořádaných případů",
    "ps.projectList.donePercentage": "Celkový stav vypořádání v %",
    "ps.projectList.expropriationTotal": "Vyvlastnění počet případů celkem",
    "ps.projectName": "Název projektu",
    "ps.projectManager": "Manažer projektu",
    "ps.propertyActivityProcessor": "Zpracovatel MP činností",
    "ps.projectInfo": "Projekt",
    "ps.unit": "Útvar",
    "ps.investor": "Investor",
    "ps.projectSettings": "Nastavení projektu",
    "ps.infrastructure": "Infrastruktura",
    "ps.projectStartDate": "Datum spuštění projektu",
    "ps.projectState": "Stav projektu",
    "ps.projectState.CREATED": "Připravovaný",
    "ps.projectState.STARTED": "Aktivní",
    "ps.projectState.STARTED_COMPLETE": "Aktivní",
    "ps.projectState.STARTED_PARTIAL": "Aktivní",
    "ps.projectState.PAUSED": "Pozastavený",
    "ps.projectState.FINISHED": "Uzavřený",
    "ps.case.id": "Id případu",
    "login.sending": "Přihlašování...",
    "login.loggedOut": "Byli jste odhlášeni",
    "ps.easementCoefficient": "Koeficient",
    "dashboard.name": "Dashboard",
    "dashboard.header": "Projekty",
    "ps.investorCommonName": "investora",
    "sv.templatesOrganizationalUnit": "Organizační jednotka",
    "sv.section": "Úsek",
    "sv.section.invest": "Úsek výstavby",
    "sv.section.additional": "Úsek provozní"
  }
}
